import { Observable } from 'rxjs'
import { ValidatedSelectOptionModel } from '../../validations/validated-dropdown.component'

export abstract class CommissionLevelGateway {
    abstract getAllCommissionLevel(filter: string): Observable<ValidatedSelectOptionModel[]>
}
